import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    appID = 'manualradar';

    setItem(itemName: string, value: any): void {
        localStorage.setItem(this.appID + '_' + itemName, JSON.stringify(value));
    }

    getItem(itemName: string): any {
        const item = localStorage.getItem(this.appID + '_' + itemName)
        if (item) {
            return JSON.parse(item);
        } else {
            return null;
        }
    }

    removeItem(itemName: string): void {
        localStorage.removeItem(this.appID + '_' + itemName);
    }
}
